import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import classNames from 'classnames';
import Theme from 'styles/theme';
import {scorecardResultScoreToHoverColor} from 'utils/const';
import './AnswerBubble.styl';

export default class AnswerBubble extends React.PureComponent {
  render() {
    const {isSelected, button, extraWide, onSelect, darkenOnHover, disabled, grayBackground} =
      this.props;
    if (!button) {
      return null;
    }

    const backgroundColor = isSelected
      ? scorecardResultScoreToHoverColor.get(button.key)
      : disabled || !grayBackground
      ? 'transparent'
      : '#c4cdd8';
    const foregroundColor = isSelected ? 'white' : Theme.palette.textColor;
    return (
      <div
        className={classNames(
          'answer-bubble-wrapper',
          extraWide && 'extra-wide',
          darkenOnHover && 'darken-on-hover'
        )}>
        <FlatButton
          disabled={disabled}
          className="answer-button"
          labelStyle={{color: foregroundColor}}
          onClick={onSelect}
          style={{backgroundColor: backgroundColor}}
          label={button.label}
        />
      </div>
    );
  }
}
